import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { DescriptorRoutes } from 'DescriptorRoutes';

import { useAppMeta } from 'hooks/useAppMeta';
import { useI18n } from 'hooks/useI18n';
import { useMirrorThemeColors } from 'hooks/useMirrorTheme';
import { usePageView } from 'hooks/usePageView';
import { useUserId } from 'hooks/useUserId';
import { setAuthenticated } from 'store/auth/authSlice';
import { init } from 'store/common/thunks';

import { FullscreenSpinner } from 'components/shared/FullscreenSpinner';

export const DescriptorApp = () => {
  const { initI18n } = useI18n();

  const dispatch = useDispatch();

  const [isInitialized, setIsInitialized] = useState(false);

  const { userId, userIdQueryValue, userIdCookieValue } = useUserId();

  const isUserIdExistInCookies = useMemo(
    () => !!userIdCookieValue,
    [userIdCookieValue]
  );
  const isUserIdExistInSearch = useMemo(
    () => !!userIdQueryValue,
    [userIdQueryValue]
  );

  const isAuthenticated = useMemo(
    () => isUserIdExistInCookies || isUserIdExistInSearch,
    [isUserIdExistInCookies, isUserIdExistInSearch]
  );

  useAppMeta();
  useMirrorThemeColors();
  usePageView(false); // ? disabled page-view, enabled page-load

  useEffect(() => {
    if (isAuthenticated) {
      dispatch(init());
    }
  }, [dispatch, isAuthenticated, userId]);

  useEffect(() => {
    const initializeTranslations = async () => {
      await initI18n();
    };

    dispatch(setAuthenticated(isAuthenticated));

    initializeTranslations();

    setIsInitialized(true);
  }, [dispatch, initI18n, isAuthenticated]);

  if (!isInitialized) return <FullscreenSpinner />;

  return <DescriptorRoutes />;
};
